import {
  IPrerequisiteInstance,
  IUpdatePrerequisiteInstance,
  IUploadFilePrerequisiteInstance
} from 'shared/interfaces/prerequisite.interface';
import { http } from '../utils/axios';

class PrerequisiteService {
  private static instance: PrerequisiteService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): PrerequisiteService {
    if (!PrerequisiteService.instance) {
      PrerequisiteService.instance = new PrerequisiteService();
    }

    return PrerequisiteService.instance;
  }

  public updatePrerequisiteInstance = async (
    payload: IUpdatePrerequisiteInstance
  ) => {
    const { data } = await http<IPrerequisiteInstance>({
      url: `/prerequisiteInstances/${payload.id}`,
      method: 'PUT',
      data: payload
    });

    return data;
  };

  public uploadFile = async (payload: IUploadFilePrerequisiteInstance) => {
    const { data } = await http<IPrerequisiteInstance>({
      url: `prerequisiteInstances/${payload.id}/uploadFile`,
      method: 'POST',
      data: payload
    });

    return data;
  };
}

const instance = PrerequisiteService.getInstance();

export default instance;
